export interface GeoJsonStyleOptions {
  strokeColor: string;
  fillColor: string;
  weight?: number;
  opacity?: number;
  fillOpacity?: number;
  hoverWeight?: number;
  hoverFillOpacity?: number;
}

export const DEFAULT_CITY_BORDERS_GEOJSON_STYLE: GeoJsonStyleOptions = {
  strokeColor: '#31436b',
  fillColor: '#2c4c73',
  weight: 2,
  opacity: 1,
  fillOpacity: 0.3,
  hoverWeight: 3,
  hoverFillOpacity: 0.20,
};

export const DEFAULT_GRID_BORDERS_GEOJSON_STYLE: GeoJsonStyleOptions = {
  strokeColor: '#31436b',
  fillColor: '#2c4c73',
  weight: 2,
  opacity: 1,
  fillOpacity: 0.3,
  hoverWeight: 3,
  hoverFillOpacity: 0.20,
};
